module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Color-Collection-Video.f93ee27c.jpg";